import { createTokenInterceptor, HttpClient } from 'core/infra/http/HttpClient'

export function initApplication() {
  HttpClient.setup({
    request: createTokenInterceptor(),
  })
}
